import {Component, Input, ChangeDetectionStrategy} from "@angular/core";
import {MatRipple} from "@angular/material/core";
import {NgClass} from "@angular/common";
import {MatProgressSpinner} from "@angular/material/progress-spinner";

@Component({
	selector: 'app-icon-button',
	templateUrl: './icon-button.component.html',
	styleUrls: ['./icon-button.component.scss'],
	changeDetection: ChangeDetectionStrategy.Eager,
	imports: [MatRipple, NgClass, MatProgressSpinner]
})
export class IconButtonComponent {

	@Input() img: `assets/${string}.svg`|`assets/${string}.png`;

	@Input() disabled = false;
	@Input() loading = false;

	@Input() size: 'xs'|'s'|'m'|'l'|'xl' = 'm';
	@Input() color: 'primary'|'accent'|'accent-secondary'|'warn'|'success'|'warning'|'danger'|'transparent' = 'accent';
	@Input() type: 'default'|'stroked'|'flat'|'dashed' = 'default';
	@Input() shape: 'default'|'square'|'round' = 'default';
	@Input() rotate: 0|90|180|270 = 0;

	private _focused: boolean
	@Input()
	get focused() { return this._focused; }
	set focused(value: any) { this._focused = value != null && `${value}` !== 'false'; }

	private _background: boolean;
	@Input()
	get background() { return this._background; }
	set background(value: any) { this._background = value != null && `${value}` !== 'false'; }

	@Input() panelClass = '';

	get diameter(): number {
		switch (this.size) {
			case 'xs': return 15;
			case 's': return 17;
			case 'm': return 20;
			case 'l': return 23;
			case 'xl': return 26;
			default: return 22;
		}
	}
}
